import { BrandConfig } from './brandConfig';

function setLinkHref(selector: string, href: string): void {
  const link = document.head.querySelector<HTMLLinkElement>(selector);
  if (link) {
    link.href = href;
  }
}

/**
 * Points the favicon, apple-touch-icon, and web app manifest at the current
 * brand's assets. index.html ships with the MRR set as the default, so this
 * only rewrites the links when another brand is active.
 */
export function applyBrandFavicon(brand: BrandConfig): void {
  const publicUrl = process.env.PUBLIC_URL ?? '';
  const folder = `${publicUrl}/favicon/${brand.faviconFolder}`;

  setLinkHref('link[rel="apple-touch-icon"]', `${folder}/apple-touch-icon.png`);
  setLinkHref('link[rel="icon"][sizes="32x32"]', `${folder}/favicon-32x32.png`);
  setLinkHref('link[rel="icon"][sizes="16x16"]', `${folder}/favicon-16x16.png`);
  setLinkHref('link[rel="manifest"]', `${publicUrl}${brand.manifestUrl}`);
}
